<div *ngIf="showErrors" class="alert valign-children-middle" id="error-main-container">
    <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
        <i class="icon-badgealert"></i>
    </div>
    <div>
        <h2>Error</h2>
        <p>{{signupSetupError || 'Something went wrong. Please try again.'}}</p>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
    </div>
</div>
<div *ngIf="setupError" class="alert valign-children-middle" id="error-main-container">
    <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
        <i class="icon-badgealert"></i>
    </div>
    <div>
        <span>{{reviewSignupSetup.errorMessage1}}
            <a href="/businessconsole/productselection" >{{reviewSignupSetup.errorMessage2}}</a>.
        </span>
    </div>
</div>


<div *ngIf="depError" class="alert valign-children-middle" id="error-main-container">
    <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
        <i class="icon-badgealert"></i>
    </div>
    <div *ngIf="showFansFlag">
        <span>{{reviewSignupSetup.depErrorMsg1}}</span>
        <span *ngFor="let fan of failArray; let i = index">{{fan}}<span *ngIf="i < failArray.length-1">, </span></span>
        <span>{{reviewSignupSetup.depErrorMsg2}}</span>
        <a (click)="clickBack()">{{reviewSignupSetup.depErrorMsg3}}</a>
        <span>{{reviewSignupSetup.depErrorMsg4}}</span>
    </div>
    <div *ngIf="!showFansFlag">
        <span>{{reviewSignupSetup.depErrorMsg1}}</span>
        <span>{{reviewSignupSetup.depErrorMsg5}}</span>
        <span>{{reviewSignupSetup.depErrorMsg2}}</span>
        <a (click)="clickBack()">{{reviewSignupSetup.depErrorMsg3}}</a>
        <span>{{reviewSignupSetup.depErrorMsg4}}</span>
    </div>
</div>
<div class="msg-box review-page">
    <h5>Step 3 of 3</h5>
    <div class="review-section">
        <div *ngIf="isFEFailed" class="alert valign-children-middle" id="error-main-container2">
            <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
                <i class="icon-badgealert"></i>
            </div>
            <div>
                <h2>Error</h2>
                <p style="padding-left:0px !important; margin-bottom: 0px !important;">{{ABMFEErrorMessage}}</p>
                <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
            </div>
        </div>

        <div *ngIf="isFEFailedWithError" class="alert valign-children-middle" id="error-main-container2">
            <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
                <i class="icon-badgealert"></i>
            </div>
            <div>
                <!-- <h2>Error</h2> -->
                <p class="marginBottomZero">{{ABMFEErrorMessage}}</p>
                <div *ngIf="errorDescShow" style="padding:5px !important">
                    <ul class="errorDescr" style="margin-bottom: 15px !important; ">
                        <li style="list-style-type: disc !important;" *ngFor="let err of ABMFEErrorMessageDescription">{{err}}</li>
                    </ul>
                    <p style="padding-left:0px !important; margin-bottom: 0px !important;">{{ABMFEErrorMessageFooter}}</p>
                </div>
                <a href="javascript:void(0);" class="showMore" (click)="errorDescShow=!errorDescShow">{{!errorDescShow ? 'See more': 'See less'}}</a>
                <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
            </div>
        </div>
        
        <p class="review-heading">{{reviewSignupSetup.reviewHeading}}</p>
        <p *ngIf="kme">{{reviewSignupSetup.kmeDescription1}}</p>
        <p *ngIf="!kme">{{reviewSignupSetup.subHeading}}:</p>
        <div class="review-info review-info-new">
            <div class="second-block review-blocks" *ngIf="abm">
                <p class="review-block-heading">{{reviewSignupSetup.productId2}}</p>
                <p class="review-block-value" *ngIf="proddets.selectedAccID == 'Pending'">{{proddets.selectedAccID}}</p>
                <span *ngIf="proddets.selectedAccID != 'Pending'"><p class="review-block-value">{{proddets.selectedAccID}}</p></span>
            </div>
            <div class="second-block review-blocks" *ngIf="kme">
                <p class="review-block-heading">{{reviewSignupSetup.productId3}}</p>
                <p class="review-block-value">{{proddets.selectedAccID}}</p>
            </div>
            <div class="second-block review-blocks" *ngIf="ztp">
                <p class="review-block-heading">{{reviewSignupSetup.productId1}}</p>
                <p class="review-block-value">{{proddets.selectedAccID}}</p>
            </div>
            <div class="first-block review-blocks">
                <p class="review-block-heading" *ngIf="!isMobileView">{{reviewSignupSetup.fanLabel}}</p>
                <p class="review-block-heading" *ngIf="isMobileView">{{reviewSignupSetup.fanLabel == "Foundation account(s)" ? "Account(s)" : "Foundation account(s)"}}</p>
                <span *ngIf="!isMobileView"><p class="review-block-value" *ngFor="let fan of signupArray">{{fan.fanId}}</p></span>
                <span *ngIf="isMobileView"><p class="review-block-value"  *ngFor="let fan of signupArray">{{fan.fanId}} - {{fan.status}}</p></span>
            </div>
            
            <div *ngIf="!isMobileView" class="third-block review-blocks">
                
                <p class="review-block-heading">{{reviewSignupSetup.existingDevices}}</p>
                <p class="review-block-value" *ngFor="let fan of signupArray">{{fan.status}}</p>
            </div>
            
        </div>
        <br>
    </div>
    <hr style="margin-bottom:17px !important">
    <div class="terms-section">
        <p class="terms-heading"><strong>Review and Accept Terms and Conditions</strong></p>
        <p class="terms-description">To complete your device enrollment registration, please review and accept the Terms and Conditions for the AT&T Device Management Program.</p>
        <div class="terms-link-box">
            <!-- <a href="{{reviewSignupSetup.termsAndConditionsURL}}" target="_blank">AT&T Device Management Program Terms and Conditions</a> -->
            <a href="{{reviewSignupSetup.termsAndConditionsURL}}" target="_blank">AT&T Device Management Program Terms and Conditions</a>
        </div>
        <div class="confirm-section">
            <label class="checkbox" for="confirmSubmission">
                <input aria-describedby="confirmSubmit" #confirm type="checkbox" id="confirmSubmission"
                    aria-label="Confirm Submission" name="Confirm Submission" (click)="enableSubmit()">
                <i class="skin"></i>
                <span id="confirmSubmit">By selecting this box, I agree to the AT&T Device Management Program Terms and Conditions on behalf of my organization, for which I am an authorized representative.</span>
            </label>
        </div>
    </div>
        <div class="model-cover terms" *ngIf = "showErrorModel && emmProductCode === 'DMPAABM'">
          <div class="model-box-loginModal">
            <div class="modal-header-loginModal"></div>
              <div class="corner-button">
                <button class="close" aria-label="Close" (click)="closeOverviewModal()">x</button>
              </div>
              <h2 class="modalHeading">Heads up!</h2>
              <p class="confirm-msg">During the registration process, AT&T will submit a test device enrollment request to Apple to validate your Apple Org ID.</p>
              <p class="confirm-msg">You may receive an email from Apple with the subject "Submission Error" referencing an order number containing the word TEST.</p>
              <div>
                <img src="assets/img/Apple_errorModal_confirmation_updated.svg" alt="" aria-label="Apple submission error modal">
              </div>
                    <div class="confirmation-span" id="confirmSubmit"><strong>No action is needed on your part.</strong></div>
                <!-- <div class="continue-div">
                    <button class="btn btn-secondary labels-inline continue-btn" id="confirmModel"
                    (click)="continueErrorModal()">I understand</button>
                </div> -->
          </div> 
        </div>
    <div class="submit-section">
        <button class="btn btn-secondary labels-inline continue-btn" id="finishEnrollment" [disabled]="isDisabled"
            (click)="continueToNext()">{{reviewSignupSetup.finishEnrollment}}</button>
        <button id="cancel-link" (click)="clickBack()"
            class="labels-inline back-btn">{{reviewSignupSetup.cancel}}</button>
    </div>
</div>